import { apiClient } from '@/api/client'

/** 再 OCR ジョブの状態 */
export type OcrJob = {
  id: number
  product_id: number
  status: 'pending' | 'running' | 'completed' | 'failed'
  progress: number
  total_pages: number
  processed_pages: number
  message: string
  error: string | null
  created_at: string
  started_at: string | null
  completed_at: string | null
}

/**
 * 作品内の PDF を Yomitoku で再 OCR するジョブを登録する（管理者のみ）
 */
export const requestProductOcr = async (productId: number): Promise<OcrJob> => {
  const res = await apiClient.post(`/p/${productId}/ocr`)
  return res.data
}

/**
 * 指定作品の未完了ジョブを取得する（なければ null）
 */
export const getProductOcrJob = async (productId: number): Promise<OcrJob | null> => {
  const res = await apiClient.get(`/p/${productId}/ocr`)
  return res.data
}

/**
 * 自分の再 OCR ジョブ履歴を取得する（管理者のみ）
 */
export const getOcrJobs = async (): Promise<OcrJob[]> => {
  const res = await apiClient.get('/ocr-jobs')
  return res.data
}
